import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
export const SoftwaresSkillsSection = styled.div`
    padding-top: .5rem;
    >h4{
        margin-bottom:.5rem;
        font-family:${({ theme }) => theme.font.first};
        font-weight:700;
        color: ${({ theme }) => theme.color.fourth};
    }
`
export const SoftwaresSkillsCard = styled.div`
    padding: 1rem;
    background-color: ${({ theme }) => theme.color.third};
    border-radius:5px;
    height: 18rem;
    div:last-child{
        margin-bottom:0rem
    }
`